import React, { FunctionComponent } from 'react';
import { map, addIndex } from 'ramda';
import { Grid, Icon, List } from 'semantic-ui-react';
import withStyles from 'react-jss';
import classnames from 'classnames';

import { ClassProp } from 'helpers/types';
import { ChartLegend } from 'components/TransactionsChart/TransactionsChart.helpers';

const styles = {
  legend: {
    display: 'flex !important',
    fontSize: '.75rem !important',
    justifyContent: 'center !important',
  },
  legendItem: {
    fontSize: '.75rem !important',
    lineHeight: '1rem !important',
    whiteSpace: 'nowrap !important',
  },
  legendItemLarge: {
    fontSize: '1.1rem !important',
    lineHeight: '1.1rem !important',
    whiteSpace: 'nowrap !important',
  },
  legendContainer: {
    display: 'flex !important',
    flexDirection: 'row !important',
    justifyContent: 'space-around !important',
    flexWrap: 'wrap !important',
  },
};

type Props = {
  legend: ChartLegend[];
  classes: ClassProp<typeof styles>;
  isLarge?: boolean;
};

const mapIndexed = addIndex<ChartLegend>(map);
const renderLegendItem = (
  classes: ClassProp<typeof styles>,
  isLarge?: boolean,
) => ({ title, color }: ChartLegend, idx: number) => (
  <List.Item key={idx}>
    <List.Content
      className={classnames({
        [classes.legendItem]: !isLarge,
        [classes.legendItemLarge]: isLarge,
      })}
    >
      <Icon name="circle" style={{ color }} />
      {title}
    </List.Content>
  </List.Item>
);

const Legend: FunctionComponent<Props> = ({
  classes,
  legend,
  isLarge = false,
}) => (
  <Grid.Column className={classes.legend}>
    <List className={classes.legendContainer} horizontal>
      {mapIndexed(renderLegendItem(classes, isLarge), legend)}
    </List>
  </Grid.Column>
);

export default withStyles(styles)(Legend);
